import { render, staticRenderFns } from "./download-wrap.vue?vue&type=template&id=0e4fbe9e&"
import script from "./download-wrap.vue?vue&type=script&lang=js&"
export * from "./download-wrap.vue?vue&type=script&lang=js&"
import style0 from "./download-wrap.vue?vue&type=style&index=0&id=0e4fbe9e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports